define(['./core/core', './chartComponent', '../js/manager/chartConfig/config.js'], function(core, chartComponent, config) {
    "use strict";
    var $ = core.$;
    var clone = core.Util.clone;

    function parseSettings(allSettings) {
        if (!allSettings) {
            return;
        }
        var storeSettings = allSettings.storeSettings;
        if ($.isArray(storeSettings)) {
            storeSettings = storeSettings.join("");
        }
        if (typeof(storeSettings) === "string") {
            storeSettings = storeSettings.replace(/\r/g, "");
            storeSettings = storeSettings.replace(/\n/g, "");
            try {
                storeSettings = JSON.parse(storeSettings);
            } catch (e) {
                storeSettings = null;
            }
        }
        return storeSettings;
    }

    function init(container, component, actionHandler) {
        var configuration = component.configuration || {};
        if (configuration.investment) {
            configuration.mainTicker = configuration.investment;
        }
        configuration.container = container;
        configuration.actionHandler = actionHandler;
        $.extend(configuration, component.callbacks);
        $.extend(configuration, {
            callbacks: component.callbacks
        });
        var instance = chartComponent();
        instance.isInited = false;
        // Used to control the init step, we can rebuild configuration before component init.
        // will be used in the API component
        if (!configuration.skipInit) {
            this.isInited = true;
            instance.init(configuration);
        }
        instance.setInvestment = function(investment) {
            instance.changeMainTicker(clone(investment));
        };
        // only for DWM to restore settings
        instance.setSettings = function(value) {
            if (!this.isInited) {
                // DWM store setting is string array and 250 length restriction. So we restrore with join.
                var savedConfig = parseSettings(value);
                this.isInited = true;
                configuration.savedConfig = savedConfig;
                instance.init(configuration);
            }
        };
        return instance;
    }

    return {
        init: init,
        properties: {
            needTrack: true,
            setter: {
                'parentSize': 'changeSize',
                'investment': 'setInvestment',
                'growthBaseValue': 'changeGrowthBaseValue',
                'compareTickers': 'updateCompareTickers',
                'skin': 'changeSkin',
                'settings': 'setSettings', //only for DWM to restore settings
                'refresh': 'refreshChart'
            },
            getter: {
                'configuration': 'getSaveConfig'
            },
            events: {
                'load': 'onLoad',
                'mainTickerDrawEnd': 'onMainTickerDrawEnd',
                'close': 'onClose',
                'click': 'triggerClickCallback',
                'addCompareTickers': 'onAddCompareTickers',
                'removeCompareTickers': 'onRemoveCompareTickers',
                'heightChange': 'onHeightChange',
                'tickerRemoveBtnClicked': 'onTickerRemoveBtnClicked',
                'configChange': 'onConfigChange',
                'fullyRendered': 'onFullyRendered',
                'complete':'onComplete',
                'error': 'onError',
                'beforeZoomIn': 'onbeforeZoomIn',
                'dateRangeChange': 'onDateRangeChange',
                'frequencyChange': 'onChangeFrequency'
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./components/svgchart/src/js/svgchart.js
// module id = 2
// module chunks = 0